import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo" aria-label="Site footer">
      <div className="container-fluid">
        <div className="footer-content">
          <div className="footer-copyright">
            <p className="footer-text mb-0">
              Copyright ©{new Date().getFullYear()} TriServe Energy, Inc. All Rights Reserved.
            </p>
          </div>
          <div className="footer-links">
            <nav className="footer-nav" aria-label="Footer navigation">
              <a href="#" className="footer-link">Privacy Policy</a>
              <span className="footer-separator">|</span>
              <a href="#" className="footer-link">Terms & Conditions</a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
